import axios from 'axios';
import Auth from '../../utils/auth';
import Parse from '../../utils/parse';
import { newError } from '../errors';
import * as actionTypes from '../../constants/actions';
import * as endpoints from '../../constants/endpoints';
import { getUniqueDeviceId } from '../../../app/utils/device';
import { canHandleCookie } from '../../utils/platform';
import { socketDisconnect } from '../socket';

const logoutDeviceStart = () => ({
  type: actionTypes.USER_LOGOUT_DEVICE,
  status: 'started',
});

const logoutDeviceSuccess = (deviceId, dispatch) => {
  dispatch({
    type: actionTypes.USER_LOGOUT_DEVICE,
    status: 'success',
    deviceId,
  });
};

const logoutDeviceError = (error, dispatch) => {
  dispatch(newError(error, 'logoutDevice'));
  dispatch({
    type: actionTypes.USER_LOGOUT_DEVICE,
    status: 'error',
    error,
  });
};

export const logoutDevice = (deviceId) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch(logoutDeviceStart());
    const { user } = getState().user;
    axios
      .post(endpoints.LOGOUT(), {
        email: user.username,
        sessionToken: user.sessionToken,
        deviceId,
      })
      .then(
        () => {
          logoutDeviceSuccess(deviceId, dispatch);
          resolve();
        },
        (err) => {
          logoutDeviceError(err, dispatch);
          reject(err);
        }
      );
  });

export const logout = () => (dispatch, getState) =>
  new Promise((resolve) => {
    if (!getState().user.isLogged) {
      const err = 'User not logged in';
      resolve(err);
      return;
    }

    dispatch(socketDisconnect());

    const domain = getState().institution.general.institution;
    const email = getState().user.user.username;
    let cookieEmail = '';
    if (canHandleCookie) cookieEmail = Auth.getActiveUserInDomain(domain);

    getUniqueDeviceId().then((deviceId) => {
      dispatch(logoutDevice(deviceId)).then(
        () => {
          dispatch({
            type: actionTypes.USER_LOGOUT,
            status: 'started',
          });
          // deleteCookie('aula-logged', '', '.aula.education');
          if (canHandleCookie) Auth.setLoggedOut(domain, cookieEmail || email);
          Parse.User.logOut().then(
            () => {
              dispatch({
                type: actionTypes.USER_LOGOUT,
                status: 'success',
              });

              resolve();
            },
            (err) => resolve(err)
          );
        },
        () => {
          dispatch({
            type: actionTypes.USER_LOGOUT,
            status: 'started',
          });
          // deleteCookie('aula-logged', '', '.aula.education');
          if (canHandleCookie) Auth.setLoggedOut(domain, cookieEmail || email);
          Parse.User.logOut().then(
            () => {
              dispatch({
                type: actionTypes.USER_LOGOUT,
                status: 'success',
              });

              resolve();
            },
            (err) => resolve(err)
          );
        }
      );
    });
  });
